import { useNavigate } from 'react-router-dom';
import { ArrowRight, ClipboardList, FileText, Gavel, Handshake, Headset } from 'lucide-react';

const featureItems = [
  { icon: FileText, label: 'Atas de registros de preços' },
  { icon: Handshake, label: 'Contratos e fornecimentos' },
  { icon: Gavel, label: 'Processos licitatórios' },
  { icon: Headset, label: 'Suporte especializado' },
];

export default function PublicServiceSection() {
  const navigate = useNavigate();

  return (
    <section id="licitacoes" className="bg-white px-4 md:px-8 lg:px-12 xl:px-16 py-4 pb-8">
      <div className="relative overflow-hidden rounded-lg bg-[#06172f] px-6 py-8 md:px-10 md:py-10 text-white shadow-[0_14px_34px_rgba(5,16,35,0.22)]">
        <div className="absolute right-0 top-0 h-full w-1/3 bg-[radial-gradient(circle_at_90%_50%,rgba(0,200,83,0.18),transparent_42%)]" />
        <div className="absolute right-8 top-8 hidden h-40 w-28 bg-[radial-gradient(circle,rgba(0,200,83,0.18)_1px,transparent_1px)] [background-size:14px_14px] lg:block" />

        <div className="relative grid grid-cols-1 lg:grid-cols-[1.1fr_1px_0.95fr] gap-8 lg:gap-10 items-center">
          <div>
            <p className="mb-3 text-xs font-extrabold uppercase tracking-wide text-donnos-green">
              LICITAÇÕES E ATAS
            </p>
            <h2 className="mb-4 text-2xl md:text-3xl font-extrabold leading-tight">
              Atendimento especializado para{' '}
              <span className="text-donnos-green">compras públicas e corporativas</span>
            </h2>
            <p className="mb-8 max-w-2xl text-sm leading-relaxed text-slate-300">
              Facilitamos o processo de consulta, cotação e fornecimento por meio de atas, contratos e oportunidades comerciais, oferecendo suporte ágil para empresas e instituições públicas.
            </p>

            <div className="grid grid-cols-2 gap-4 sm:grid-cols-4">
              {featureItems.map(({ icon: Icon, label }) => (
                <div key={label} className="flex items-center gap-3 text-xs font-semibold text-slate-200">
                  <Icon className="h-8 w-8 text-donnos-green shrink-0 stroke-[1.6]" aria-hidden="true" />
                  <span>{label}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="hidden h-full w-px bg-white/15 lg:block" />

          <div className="rounded-xl bg-white/7 p-6 md:p-8">
            <div className="grid grid-cols-1 sm:grid-cols-[auto_1fr] gap-6 items-center">
              <ClipboardList className="h-24 w-24 text-donnos-green stroke-[1.5]" aria-hidden="true" />
              <div>
                <h3 className="mb-3 text-2xl font-extrabold text-white">Consulta de Atas</h3>
                <p className="mb-6 text-sm leading-relaxed text-slate-300">
                  Encontre oportunidades, produtos e condições comerciais disponíveis para atendimento da sua instituição.
                </p>
                <button
                  onClick={() => navigate('/atas')}
                  className="inline-flex items-center gap-3 rounded-md bg-donnos-green px-6 py-3 text-sm font-bold text-white transition-colors hover:bg-donnos-green-dark"
                >
                  Consultar agora
                  <ArrowRight className="h-4 w-4" aria-hidden="true" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
